
export default {

  data() {
    let checkName = (rule, value, callback)=>{
      console.log(value)
      if(!(/^[a-zA-Z]/).test(value)){
        callback(new Error('字段名以字母开头'))
      }
      if(this.metadataForm.dataSourceType=='mysql'){
        if (!value||value.length < 1 || value.length > 64) {
          callback(new Error('长度在1-64个长度之间'))
        }
      }else if(this.metadataForm.dataSourceType=='hive'){
        if (!value||value.length < 1 || value.length > 128) {
          callback(new Error('长度在1-128个长度之间'))
        }
      }
      var flag = new RegExp('[`~!@#$^&*()=|{}\':;\',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？ ]')
      if (flag.test(value)) {
        callback(new Error('请检查输入,不能含有特殊字符'))
      }

      let i = 0
      this.metadataForm.metaColumns.forEach((item)=>{
        if(item.columnName==value){
          i++
        }
      })
      this.metadataForm.metaPartColumns.forEach((item)=>{
        if(item.columnName==value){
          i++
        }
      })
      if(i!=1){
        callback(new Error('字段名不能重复'))
      }

      callback()
    }

    let checkIndexName = (rule, value, callback)=>{
      if (!value) {
        callback(new Error('请选择索引字段'))
      }
      //这里要对数组value进行遍历校验
      if(typeof(value)=='object'){
        value.forEach((item)=>{
          if(this.metadataForm.metaColumns.findIndex(item2=>item2.columnName==item)==-1){
            callback(new Error('请检查更名字段并重新选择索引字段'))
          }
        })
      }else {
        if(this.metadataForm.metaColumns.findIndex(item2=>item2.columnName==value)==-1){
          callback(new Error('请检查更名字段并重新选择索引字段'))
        }
      }

      callback()
    }

    return {

      metadataForm: {
        deleteIndexIds:[],
        deleteColumnIds:[],

        ddl:'',

        createMethod: '1',
        dataSourceType: '',
        metaDataSourceId: '',
        dataBaseId: '',
        metaLabels: [],
        updateFrequency: 3,
        resPerson: this.$store.getters.userInfo.realname,
        tableDesc: '',

        metaTable:{
          //存储路径
          tableStorage: '',
          //表分组
          tableType: '',
          //存储格式
          tableStorageFormat: 'parquet',
          //字段划分格式
          tableDivisionFormat:'',

          hiveLayered: '',
          hiveTableName: '',
          hiveSyncType: '',
          hivePartition: '',

          mysqlTableName:'',
          mysqlSyncType:'',
        },

        metaColumns: [],

        metaPartColumns:[],

        metaMysqlIndexUpdateVos:[],
      },

      dataSourceTypeOptinons:[{ label: 'mysql', value: 'mysql' }, { label: 'hive', value: 'hive' }, { label: 'doris', value: 'doris' }],
      metaDataSourceIdOptions:[],
      dataBaseIdOptions:[],
      updateFrequencyOptions:[{ label: 'h+0', value: 1 }, { label: 'h+1', value: 2 }, { label: 't+1', value: 3 }, { label: 'w+1', value: 4 }, { label: 'm+1', value: 5 }, { label: '手动更新', value: 6 }, { label: 'h+0.5', value: 7}],
      metaLabelsOptions:[{ label: 'mysql', value: '1' }, { label: 'hive', value: '2' }, { label: 'doris', value: '0' }],
      indexMethodOptions: [{ label: 'HASH', value: 'HASH' }, { label: 'BTREE', value: 'BTREE' }],
      indexTypeOptions: [{ label: '普通索引', value: 2 }, { label: '唯一索引', value: 3 }, { label: '组合索引', value: 4 }],
      columnTypeOptions: [{ label: 'boolean', value: 'boolean' }, { label: 'tinyint', value: 'tinyint' }, { label: 'smallint', value: 'smallint' }, { label: 'int', value: 'int' },
        { label: 'bigint', value: 'bigint' }, { label: 'float', value: 'float' }, { label: 'double', value: 'double' }, { label: 'deicimal', value: 'deicimal' },
        { label: 'String', value: 'String' }, { label: 'varchar', value: 'varchar' }, { label: 'char', value: 'char' }, { label: 'binary', value: 'binary' },
        { label: 'timestamp', value: 'timestamp' }, { label: 'date', value: 'date' }, { label: 'array', value: 'array' }, { label: 'map', value: 'map' },
        { label: 'struct', value: 'struct' }],
      mysqlTypeOptions: [{ label: 'TINYINT', value: 'TINYINT' }, { label: 'SMALLINT', value: 'SMALLINT' }, { label: 'MEDIUMINT', value: 'MEDIUMINT' }, { label: 'INT', value: 'INT' },
        { label: 'INTEGER', value: 'INTEGER' }, { label: 'BIGINT', value: 'BIGINT' }, { label: 'FLOAT', value: 'FLOAT' }, { label: 'DOUBLE', value: 'DOUBLE' },
        { label: 'DECIMAL', value: 'DECIMAL' }, { label: 'DATE', value: 'DATE' }, { label: 'TIME', value: 'TIME' }, { label: 'YEAR', value: 'YEAR' },
        { label: 'DATETIME', value: 'DATETIME' }, { label: 'TIMESTAMP', value: 'TIMESTAMP' }, { label: 'CHAR', value: 'CHAR' }, { label: 'VARCHAR', value: 'VARCHAR' },
        { label: 'TINYBLOB', value: 'TINYBLOB' }, { label: 'TINYTEXT', value: 'TINYTEXT' }, { label: 'BLOB', value: 'BLOB' }, { label: 'TEXT', value: 'TEXT' }
        , { label: 'MEDIUMBLOB', value: 'MEDIUMBLOB' }, { label: 'MEDIUMTEXT', value: 'MEDIUMTEXT' }, { label: 'LONGBLOB', value: 'LONGBLOB' }, { label: 'LONGTEXT', value: 'LONGTEXT' }],
      hiveLayeredOptions: [{ label: 'ODS', value: 'ODS' }, { label: 'DWD', value: 'DWD' }, { label: 'DWS', value: 'DWS' }, { label: 'DIM', value: 'DIM' },
        { label: 'TMP', value: 'TMP' }, { label: 'ADS', value: 'ADS' }],
      hiveSyncTypeOptions: [{ label: '全量更新', value: 'full' }, { label: '增量更新', value: 'inc' }],
      hivePartitionOptions: [{ label: '0p', value: '0p' }, { label: '1h', value: '1h' }, { label: '1d', value: '1d' }, { label: '1w', value: '1w' },
        { label: '1m', value: '1m' }, { label: '1y', value: '1y' }],
      tableStorageFormatOptinons:[{ label: 'RC', value: 'rcfile' }, { label: 'ORC', value: 'orcfile' },{ label: 'textfile', value: 'textfile' }, { label: 'Parquet', value: 'parquet' }],

      metadataRules:{
        dataSourceType:[
          { required: true, message: '请选择数据源类型', trigger: 'change' },
        ],
        metaDataSourceId:[
          { required: true, message: '请选择数据源名称', trigger: 'change' },
        ],
        dataBaseId:[
          { required: true, message: '请选择数据库名称', trigger: 'change' },
        ],
        updateFrequency:[
          { required: true, message: '请选择更新频率', trigger: 'change' },
        ],
        tableDesc:[
          { required: true, message: '请输入备注', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        // tableDivisionFormat:[
        //   { required: true, message: '请输入字段划分格式', trigger: 'blur' },
        // ],
        tableStorageFormat:[
          { required: true, message: '请选择存储格式', trigger: 'change' },
        ],
        hiveLayered:[
          { required: true, message: '请选择表分层', trigger: 'change' },
        ],
        hiveTableName:[
          { required: true, message: '请填写表名', trigger: 'blur' },
        ],
        mysqlTableName:[
          { required: true, message: '请填写表名', trigger: 'blur' },
        ],
        hiveSyncType:[
          { required: true, message: '请选择增全量', trigger: 'change' },
        ],
        mysqlSyncType:[
          { required: true, message: '请选择增全量', trigger: 'change' },
        ],
        hivePartition:[
          { required: true, message: '请选择分区', trigger: 'change' },
        ],
        columnName:[
          { required: true, validator: checkName, trigger: 'blur' },
        ],
        columnDesc:[
          { required: true, message: '请输入字段描述', trigger: 'blur' },
        ],
        columnType:[
          { required: true, message: '请选择字段类型', trigger: 'change' },
        ],
        metaColumns:[
          { required: true, validator: checkIndexName, trigger: 'change' },
        ],
        indexType:[
          { required: true, message: '请选择索引类型', trigger: 'change' },
        ],
        indexName:[
          { required: true, message: '请输入索引名称', trigger: 'blur' },
        ],
        indexMethod:[
          { required: true, message: '请选择索引方法', trigger: 'change' },
        ],

      },

    }
  },

  methods: {

  }
}
